import type { InjectionKey } from 'vue';
import { TdDescriptionsProps } from '../type';

export const descriptionsKey: InjectionKey<TdDescriptionsProps> = Symbol('TDescriptions');
